import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PaymentErrorDialogData {
    code: string;
    message: string;
}

@Component({
    selector: 'odq-payment-error-dialog',
    templateUrl: 'payment-error-dialog.html',
    standalone: false
})
export class PaymentErrorDialog implements OnInit {

    codes: string[];

    constructor(public dialogRef: MatDialogRef<PaymentErrorDialog>,
        @Inject(MAT_DIALOG_DATA) public data: PaymentErrorDialogData) {

    }

    ngOnInit() {
        const codeString = this.data?.code + '';
        this.codes = codeString?.split(',');
    }

}
